/*============================================================
   REACT DEPENDENCIES
============================================================*/
import { useState, useEffect } from "react";

/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { useDispatch, useSelector } from "react-redux";

import Grid from "@mui/material/Grid2";
import FormHelperText from "@mui/material/FormHelperText";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Typography from "@mui/material/Typography";

import GridSectionHeader from "../../widgets/GridSectionHeader";
import GridTextfield from "../../widgets/GridTextfield";

import { valudateTextfield2 } from "../../../utils/fieldValidator.js";

import { updateDependantNeeds } from "../../../states/slcObjectives.js";

export default function DependantNeeds() {
  const dependantNeeds = useSelector(
    (state) => state.objectives.protection.dependantNeeds
  );

  const [depName1, setDepName1] = useState(dependantNeeds.depName1);
  const [depName2, setDepName2] = useState(dependantNeeds.depName2);
  const [depName3, setDepName3] = useState(dependantNeeds.depName3);
  const [depName4, setDepName4] = useState(dependantNeeds.depName4);

  const [deviationReason, setDeviationReason] = useState(
    dependantNeeds.deviationReason
  );

  const [depName1Error, setDepName1Error] = useState();
  const [depName2Error, setDepName2Error] = useState();
  const [depName3Error, setDepName3Error] = useState();
  const [depName4Error, setDepName4Error] = useState();

  const [deviationReasonError, setDeviationReasonError] = useState();

  const dispatch = useDispatch();

  //COMPONENT ID
  let id = "";

  function updateRedux(fieldName, fieldValue, reducer) {
    const action = {
      type: fieldName,
      payload: fieldValue,
    };
    dispatch(reducer(action));
  }

  function handleChange(e, object) {
    let input_data = {
      event: e,
      fieldName: "",
      fieldVariable: "",
      isMandatory: false,
    };

    //TEXTFIELDS
    id = e.target.id;
    validateFields(e, id, input_data);
  }

  function validateFields(e, id, input_data) {
    if (id === "depName1") {
      input_data.fieldName = "Dependency 1";
      input_data.fieldVariable = depName1;
      const result = valudateTextfield2(input_data);
      if (result.errorMessage === "") {
        setDepName1(result.value);
        updateRedux("depName1", result.value, updateDependantNeeds);
      }

      setDepName1Error(result.errorMessage);
    }

    if (id === "depName2") {
      input_data.fieldName = "Dependency 2";
      input_data.fieldVariable = depName2;
      const result = valudateTextfield2(input_data);
      if (result.errorMessage === "") {
        setDepName2(result.value);
        updateRedux("depName2", result.value, updateDependantNeeds);
      }

      setDepName2Error(result.errorMessage);
    }

    if (id === "depName3") {
      input_data.fieldName = "Dependency 3";
      input_data.fieldVariable = depName3;
      const result = valudateTextfield2(input_data);
      if (result.errorMessage === "") {
        setDepName3(result.value);
        updateRedux("depName3", result.value, updateDependantNeeds);
      }

      setDepName3Error(result.errorMessage);
    }

    if (id === "depName4") {
      input_data.fieldName = "Dependency 4";
      input_data.fieldVariable = depName4;
      const result = valudateTextfield2(input_data);
      if (result.errorMessage === "") {
        setDepName4(result.value);
        updateRedux("depName4", result.value, updateDependantNeeds);
      }

      setDepName4Error(result.errorMessage);
    }

    if (id === "deviationReason") {
      input_data.fieldName = "Deviation reason";
      input_data.fieldLength = 1000;
      input_data.fieldVariable = deviationReason;
      const result = valudateTextfield2(input_data);
      if (result.errorMessage === "") {
        setDeviationReason(result.value);
        updateRedux("deviationReason", result.value, updateDependantNeeds);
      }

      setDeviationReasonError(result.errorMessage);
    }
  }

  return (
    <>
      <Grid container spacing={1} size={12}>
        <GridSectionHeader
          sectionName="Planning for Dependants Protection"
          sx={{
            p: 1,
            pl: 1.8,
            mt: 0,
            mb: 1,
            fontSize: 18,
            fontWeight: "bold",
            color: "#FFFFFF", //WHITE
            // color: "#000000", //BLACK
            // backgroundColor: "#d9d9d9",
            backgroundColor: "#10B981",
          }}
        />

        {/*==============================
        NAME OF DEPENDANTS
        ==============================*/}
        <GridTextfield
          id="depName1"
          key="depName1"
          columnSize="6"
          currState={depName1}
          onChange={handleChange}
          error={depName1Error}
          helperText={depName1Error}
        />

        <GridTextfield
          id="depName2"
          key="depName2"
          columnSize="6"
          currState={depName2}
          onChange={handleChange}
          error={depName2Error}
          helperText={depName2Error}
        />

        <GridTextfield
          id="depName3"
          key="depName3"
          columnSize="6"
          currState={depName3}
          onChange={handleChange}
          error={depName3Error}
          helperText={depName3Error}
        />

        <GridTextfield
          id="depName4"
          key="depName4"
          columnSize="6"
          currState={depName4}
          onChange={handleChange}
          error={depName4Error}
          helperText={depName4Error}
        />

        {/*==============================
        REASON(S) FOR DEVIATIONS
        ==============================*/}
        <Typography variant="body1">Reason(s) for Deviations:</Typography>
        <TextareaAutosize
          id="deviationReason"
          placeholder="Type here..."
          style={{ width: "100%" }}
          minRows={5}
          onChange={handleChange}
          defaultValue={deviationReason}
        />
        {deviationReasonError && (
          <FormHelperText error={deviationReasonError}>
            {deviationReasonError}
          </FormHelperText>
        )}
      </Grid>
    </>
  );
}
